import TemplateView from "../../../TemplateView";
import UserNameFormat from "../../../util/UserNameFormat";
import messageResource from "../../../messageResource";
import {DateFormat} from "../../../date_format";

export default class AccountCreatedContainer extends TemplateView {
    constructor({
        onInviteOneMoreUserCb = () => {},
        onCloseCb= () => {},
    }) {
        super(null)

        this.state = {
            firstName: '',
            lastName: '',
            middleInitial: '',
            email: '',
            hireDate: null,
            invitationSent: false,
            inviteOneMoreDisabled: false,
        }

        this.callbacks = {
            onInviteOneMoreUserCb,
            onCloseCb,
        }

        this.onStateChanged(state => this._update())
    }

    templateHtml() {
        return '<div class="createUserPanel_accountCreatedContainer">' +
               '    <div class="invitationImg"/>' +
               '    <div class="invitationInfoHeader"></div>' +
               '    <div class="invitationInfo"></div>' +
               '    <div class="inviteOneMoreButton">' +
               '        <div class="addIcon"/>' +
               '        <span><%-inviteOneMoreUser%></span>' +
               '    </div>' +
               '    <div class="closeLink"><span><%-closeLink%></span></div>' +
               '</div>'
    }

    _update() {
        this.getEl().toggleClass("letterWillBeSent", !this.state.invitationSent);

        const formattedUserName = UserNameFormat.formatFML(this.state.firstName, this.state.lastName, this.state.middleInitial);
        const invitationInfoHeader = messageResource.getEscapedMessage("user.created.account_has_been_created", [formattedUserName])
        this.find(".invitationInfoHeader").html(invitationInfoHeader);

        const formattedHireDate = new DateFormat(window.SystemSettings.dateFormat).formatDate(this.state.hireDate.parseJSONDate());
        const invitationInfoText = this.state.invitationSent ?
                                 messageResource.getEscapedMessage("user.created.invitation_info.letter_sent", [this.state.email]) :
                                 messageResource.getEscapedMessage("user.created.invitation_info.hire_date_in_future", [this.state.email, formattedHireDate]);
        this.find(".invitationInfo").html(invitationInfoText);

        this.find('.inviteOneMoreButton').toggle(!this.state.inviteOneMoreDisabled)
        if (!this.state.inviteOneMoreDisabled) {
            this.find('.inviteOneMoreButton span').click(() => this.callbacks.onInviteOneMoreUserCb())
        }

        this.find(".closeLink span").click(() => this.callbacks.onCloseCb());
    }

    messageKeys() {
        return {
            inviteOneMoreUser: "user.created.invite_one_more_user",
            closeLink: "common.close"
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/AccountCreatedContainer.js